require('./ie11');

require('core-js/stable');

/**
 * We don't load polyfills in modern browsers, but regenerator-runtime is still
 * required in modern browsers if you are decompiling ES6 -> ES5 with babel. So we comment this out.
 */
// require('regenerator-runtime/runtime');
